import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import TrackVisibility from 'react-on-screen';
import { push } from 'react-router-redux';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Card, { CardContent, CardMedia } from 'material-ui/Card';
import IconButton from 'material-ui/IconButton';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';
import Grid from 'material-ui/Grid';
import Drawer from 'material-ui/Drawer';
import Button from 'material-ui/Button';
import List from 'material-ui/List';
import Divider from 'material-ui/Divider';

// Components
import Username from './components/Username';
import Description from './components/Description';
import Priority from './components/Priority';
import Age from './components/Age';
import Oar from './components/Oar';
import City from './components/City';
import ProfileImage from './components/ProfileImage';
import FullProfileButton from './components/FullProfileButton';
import MessageButton from './components/MessageButton';
import Omit from './components/Omit';

class Item extends Component {

  render(){

    const { classes, theme, location, data } = this.props;

    let color = data["color_id"]
    let color_css = classes.masterCard;

    if (color  == 1) {
      color_css = classes.masterCardBlue;
    } else if (color == 2) {
      color_css = classes.masterCardGreen;
    } else if (color == 3) {
      color_css = classes.masterCardYellow;
    } else if (color == 4) {
      color_css = classes.masterCardWhite;
    }

    const result = this.props.priority_change_array.find( item => item.access_id === data["access id"] );
    console.log("result for access id "+data["access id"]+" is "+ result)

    if (result){
      let color = result.color_id;
      color_css = classes.masterCardWhite;
    }

    if (data["Dsc_ID"] == 5) {
      color_css = classes.masterCardWhite;

      if (!window.location.href.includes("show_omit")) {
        return (<div></div>);
      }
    }

    const result_ommitted = this.props.items_ommitted.find( item => item.access_id === data["access id"] );
    if (result_ommitted) {
      color_css = classes.masterCardWhite;

/*
      if (window.location.href.includes("console/display/rapid_display_view")) {
        return (<div></div>);
      }*/
      if (!window.location.href.includes("show_omit")) {
        return (<div></div>);
      }
    }



    return(
      <div>
        <Card className={color_css}>
          <div className={classes.card}>
            <TrackVisibility partialVisibility offset={1500}>
                 {({ isVisible }) => <ProfileImage data={data} isVisible={isVisible}/>}
            </TrackVisibility>

            <div className={classes.details}>
              <CardContent className={classes.content}>
                <Username data={data}/>
                <MessageButton data={data}/>
                <Description data={data}/>
                <div className={classes.demo3}></div>
                <Grid item xs={12}>
                  <Grid container className={classes.demo} justify="left" spacing={6}>
                    <Grid>
                      <Age data={data}/>
                    </Grid>
                      <div className={classes.demo2}></div>
                    <Grid>
                      <Oar data={data}/>
                    </Grid>
                      <div className={classes.demo2}></div>
                    <Grid>
                      <City data={data}/>
                    </Grid>
                  </Grid>
                </Grid>
                <div className={classes.demo3}></div>
                <div>
                <Priority data={data} />
                </div>
                <Omit data={data}/>
              </CardContent>
            </div>
          </div>
          <FullProfileButton data={data}/>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        items_ommitted: state.item_ommitted,
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
        counter: state.counter,
        router: state.router,
        rrd_data: state.rrd_data,
        priority: state.dashboard.priority,
        priority_change_array: state.prioritychangeid
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({

    }, dispatch);
}


export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps,matchDispatchToProps)(Item)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/Item/index.js